import React, { useState } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import customGift from "../../../../../assets/images/OUR SERVICES/10.Corporate gifting.png";
import premiumGift from "../../../../../assets/images/OUR SERVICES/premium-gift.png";
import EnquiryModal from '../../../../../common/pages/enquiryModal';
const CorporateGifting = () => {
    const [modal, setModal] = useState(false);
    const toggleModal = () => setModal(!modal);
    return (
        <React.Fragment>

            <section className="section bg-light py-5" id="features">
                <Container>
                    <Row className="align-items-center gy-4">
                        <div className="text-muted">
                            <div className="text-center ">
                                <h2 className="fw-bold mt-5" style={{ fontSize: "2rem", color: "#F15A29" }}>Corporate Gifting</h2>

                            </div>
                        </div>
                    </Row>
                </Container>
            </section>

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} sm={10}>
                            <Row className="align-items-center gy-4">
                                <Col lg={6} md={12}>
                                    <img
                                        src={premiumGift}
                                        alt="Premium Corporate Gifts"
                                        className="img-fluid rounded"
                                        style={{ width: "100%", height: "auto" }}
                                    />
                                </Col>
                                <Col lg={6} md={12}>
                                    <h3 className="fw-bold " style={{ color: "rgb(52, 81, 159)" }}>Premium Corporate Gifts</h3>
                                    <p className="text-black">
                                        Impress your clients and employees with high-quality premium gifts that reflect your brand’s excellence.
                                    </p>
                                    <ul className="text-black">
                                        <li>Luxury Gift Sets</li>
                                        <li>Branded Merchandise</li>
                                        <li>Exclusive Leather Products</li>
                                        <li>Executive Pens & Accessories</li>
                                    </ul>
                                </Col>

                                <Col lg={6} md={12}>
                                    <h3 className="fw-bold " style={{ color: "rgb(52, 81, 159)" }}>Customized Branding</h3>
                                    <p className="text-black">
                                        Get creative and personalize your corporate gifts with custom branding for products and services.
                                    </p>
                                    <ul className="text-black">
                                        <li>Corporate T-shirts</li>
                                        <li>Customized Bottles & Sippers</li>
                                        <li>Branded Bags & Pens</li>
                                        <li>Personalized Cups & Accessories</li>
                                    </ul>
                                </Col>
                                <Col lg={6} md={12}>
                                    <img
                                        src={customGift}
                                        alt="Customized Branding"
                                        className="img-fluid rounded"
                                        style={{ width: "100%", height: "auto" }}
                                    />
                                </Col>

                            </Row>
                        </Col>
                    </Row>
                </Container>
                <EnquiryModal isOpen={modal} toggle={toggleModal} />
            </section>
            <section className="section  py-5" style={{ backgroundColor: " rgb(52, 81, 159)" }} id="features">
                <Container>
                    <Row className="justify-content-center">
                        <div className='text-center '>
                            <Button className='px-4 py-2 fw-bold' onClick={toggleModal}
                                style={{ background: "rgb(238, 99, 82)", borderRadius: "20px", color: "white", fontSize: "20px" }}
                            >
                                Enquiry Now
                            </Button>
                        </div>
                    </Row>
                </Container>
            </section>
        </React.Fragment >
    );
};

export default CorporateGifting;